import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Hizmetler', href: '#hizmetler' },
    { label: 'Teknoloji', href: '#teknoloji' },
    { label: 'Sonuçlar', href: '#sonuclar' },
    { label: 'Yorumlar', href: '#yorumlar' },
    { label: 'İletişim', href: '#iletisim' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/79c9aafb3c7891dd76e8052ad6a6dd8f.jpeg"
            alt="Ayfer Çetin Güzellik Salonu"
            className="h-10 md:h-12 w-auto object-contain rounded-lg"
          />
          <div className="hidden sm:block">
            <p className={`font-serif text-sm font-bold leading-tight transition-colors duration-300 ${scrolled ? 'text-[#2D2D2D]' : 'text-white'}`}>
              Ayfer Çetin
            </p>
            <p className={`text-xs tracking-widest uppercase transition-colors duration-300 ${scrolled ? 'text-[#D4AF37]' : 'text-[#D4AF37]'}`}>
              Güzellik Salonu
            </p>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors duration-300 hover:text-[#D4AF37] ${
                scrolled ? 'text-[#2D2D2D]' : 'text-white/90'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://wa.me/905412190629"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-2 bg-[#D4AF37] text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#B8962E] transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap"
          >
            <i className="ri-calendar-line text-sm"></i>
            Randevu Al
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors ${
            scrolled ? 'text-[#2D2D2D]' : 'text-white'
          }`}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white/98 backdrop-blur-md px-6 pb-6 pt-2">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block py-3.5 text-[#2D2D2D] font-medium border-b border-[#FFE5EC] last:border-0 hover:text-[#D4AF37] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.me/905412190629"
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-4 flex items-center justify-center gap-2 bg-[#D4AF37] text-white px-5 py-3 rounded-full text-sm font-semibold whitespace-nowrap"
          >
            <i className="ri-calendar-line"></i>
            Randevu Al
          </a>
        </div>
      </div>
    </nav>
  );
}
